import React from "react";
import { useAuth } from "../auth/Auth";
import { Redirect, Route } from "react-router";
import { useNetworkStatus } from "../networkStatus/NetworkStatus";

export const PrivateRoute = ({ children, availableOffline, ...rest }) => {
  let auth = useAuth();
  const networkStatus = useNetworkStatus();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.user || (!networkStatus && availableOffline) ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};
